<template>
  <div class="p-projects-list">
    <LoadingChara v-if="isLoading" variant="inline">
      <template slot="title">
        データ取得中
      </template>
    </LoadingChara>
    <template v-else-if="!items.length">
      <Error v-if="isAdmin || isAgency" variant="inline">
        <template slot="title">
          閲覧可能なサイトがありません。
        </template>
        <p>
          まだ代理店さま経由のユーザーがサイト登録が済んでおりません。<br />
          サイトが登録された時点で、現在の画面に各サイトが表示されます。
        </p>
        <Button variant="main" class="l-w-240" @click="reload">
          <Icon variant="return" :size="13" />
          再読み込みする
        </Button>
      </Error>
      <Error v-else-if="isAuthority" img="normal" variant="inline">
        <template slot="title">
          サイトが登録されていません。
        </template>
        <p>
          新規サイトを追加ボタンをクリックして、サイトを登録してください。
        </p>
        <Button
          :to="{ name: 'set' }"
          variant="main"
          icon="plus"
          class="l-w-240 l-pr-4"
          :disabled="isLimited"
        >
          新規サイトを追加
        </Button>
      </Error>
      <Error v-else variant="inline">
        <template slot="title">
          閲覧可能なサイトがありません。
        </template>
        <p>
          まだサイトが存在しないか、サイトのアクセス権が付与されていません。<br />あなたを招待したユーザーに確認してみてください。
        </p>
        <Button variant="main" class="l-w-240" @click="reload">
          <Icon variant="return" :size="13" />
          再読み込みする
        </Button>
      </Error>
    </template>
    <template v-else-if="!slicedItems.length">
      <Error variant="inline">
        <template slot="title">
          条件に合うサイトがありません。
        </template>
      </Error>
    </template>
    <template v-else>
      <ListItemProject
        v-for="(item, index) in slicedItems"
        :key="item.id"
        :index="index"
        :project="item"
        @delete="deleteItem"
      />
    </template>
  </div>
</template>

<script>
import Button from '@/components/Button';
import Error from '@/components/Error';
import Icon from '@/components/Icon';
import ListItemProject from '@/components/projects/ListItemProject';
import LoadingChara from '@/components/LoadingChara';

export default {
  props: {
    items: {
      type: Array,
      required: true
    },
    slicedItems: {
      type: Array,
      required: true
    },
    isLimited: {
      type: Boolean,
      required: true
    },
    isLoading: {
      type: Boolean,
      required: true
    }
  },
  components: {
    Button,
    Error,
    Icon,
    ListItemProject,
    LoadingChara
  },
  data() {
    return {};
  },
  computed: {
    organization() {
      return this.$store.getters['view/organization'];
    },
    isAdmin() {
      return this.$store.state.user.status.isAdmin;
    },
    isAgency() {
      return this.$store.state.user.status.isAgency;
    },
    isAuthority() {
      return this.organization.isAuthority;
    }
  },
  methods: {
    deleteItem() {
      this.$emit('delete');
    },
    reload() {
      location.reload(true);
    }
  }
};
</script>
